module.exports = __webpack_public_path__ + "static/laptop-e17ba93e7462d062758e5f5912c3c1b3.jpg";